import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstallmentListPageComponent } from './installment-list-page/installment-list-page.component';
import { ComponentsModule } from '../shared/components/components.module';
import { MaterialAngularModule } from '../material-design/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { InstallmentsTableComponent } from './installments-table/installments-table.component';



@NgModule({
  declarations: [
    InstallmentListPageComponent,
    InstallmentsTableComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    BrowserModule,
    MaterialAngularModule,
  ]
})
export class SecondCopyInstallmentModule { }
